<template>
<div v-if="models" class="wph-px-10 wph-relative">
  <div ref="slider" class="wph-textile-model-picker wph-pt-1 wph-pb-10 wph-relative wph-overflow-x-hidden">
    <div class="swiper-wrapper wph-flex wph-items-stretch">
      <div v-for="model in models" :key="model.textileModel"
        class="wph-textile-model-picker__card swiper-slide wph-flex wph-flex-col"
      >
        <div class="wph-textile-model-picker__image wph-cursor-pointer wph-bg-cover"
          :style="{
            backgroundImage: `url(${model.image})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }"
          @click="onModelPick(model)"
        >

        </div>
        <div class="wph-textile-model-picker__body wph-flex wph-flex-auto wph-items-center wph-px-6 wph-py-4">
          <h2 class="wph-font-bold wph-flex-auto wph-text-center">{{ model.title }}</h2>
        </div>
        <div class="wph-flex wph-items-center wph-justify-between wph-px-6 wph-py-5 wph-bg-blue-lightest">
          <div>
            <span>от</span>&nbsp;
            <span class="wph-font-bold">{{ model.priceList[model.priceList.length - 1].price }} &#x20bd;</span>
          </div>
          <button @click="onModelPick(model)" class="wph-button wph-button--small wph-text-sm">Выбрать</button>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
  <div class="wph-swiper-nav-next wph--mt-6" ref="slider-button-next">
    <div class="wph-swiper-nav-next__arrow"></div>
  </div>
  <div class="wph-swiper-nav-prev wph--mt-6" ref="slider-button-prev">
    <div class="wph-swiper-nav-prev__arrow"></div>
  </div>
</div>
</template>

<script>
import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js'
Swiper.use([Navigation, Pagination])

export default {
  name: "TextileModelPicker",
  props: ['value', 'productType'],
  data() {
    return {
      swiper: null,
    }
  },
  computed: {
    models() {
      return this.productType ? this.$store.state[this.productType.id].models : null
    }
  },
  methods: {
    onModelPick(model) {
      this.$emit('input', model)
    }
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      navigation: {
        nextEl: this.$refs['slider-button-next'],
        prevEl: this.$refs['slider-button-prev'],
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpointsInverse: true,
      breakpoints: {
        640: {
          centeredSlides: false,
          slidesPerView: 'auto',
        }
      },
    })
  },
  updated() {
    this.swiper.update()
    this.swiper.slideTo(0, 0)
  },
  beforeDestroy() {
    this.swiper.destroy()
  },
}
</script>

<style scoped>
  .swiper-slide {
    width: 272px;
    height: auto;
  }
</style>